(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vuex"));
	else if(typeof define === 'function' && define.amd)
		define("core", ["vuex"], factory);
	else if(typeof exports === 'object')
		exports["core"] = factory(require("vuex"));
	else
		root["core"] = factory(root["Vuex"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__637__) {
return 